import { isSameDay } from 'date-fns/isSameDay';
import { useMemo } from 'react';

import { getZonedDate, ZonedDate } from '@eika-infrastruktur/date';

export type DueType = 'today' | 'overdue';

const today = getZonedDate();

export const getDueType = (date: ZonedDate) => {
    if (isSameDay(date, today)) {
        return 'today';
    }
    if (date < today) {
        return 'overdue';
    }

    return null;
};

export default (date: string): DueType | null => {
    const currentDate = useMemo(() => getZonedDate(date), [date]);

    return useMemo(() => getDueType(currentDate), [currentDate]);
};
